import { render, staticRenderFns } from "./VipSubscription.vue?vue&type=template&id=81e6dbc6&scoped=true"
import script from "./VipSubscription.vue?vue&type=script&lang=js"
export * from "./VipSubscription.vue?vue&type=script&lang=js"
import style0 from "./VipSubscription.vue?vue&type=style&index=0&id=81e6dbc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81e6dbc6",
  null
  
)

export default component.exports